import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DireccionesService } from '../account/direcciones/services/direcciones.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Direcciones } from '../../entities/Direcciones';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {
  public datosReporte = [];
  showInfo: boolean = false;
  listaDirecciones: Direcciones[] = [];

  constructor(
    private route: Router,
    private toastService: ToastrService,
    private direccionesService: DireccionesService,) { }

  ngOnInit(): void {
    this.obtenerDirecciones()
  }

  obtenerDirecciones(){
    this.direccionesService.obtenerMensajes().subscribe((result: Direcciones[]) => {
      if (result.length > 0) {
        this.listaDirecciones = result
       } else {
        this.listaDirecciones = [];
        this.showInfo = true;
       }
    })
  }

  cancelar(){
    this.route.navigateByUrl('/pages/panel-usuario')
  }

  agregarDireccion(){
    this.route.navigateByUrl('/pages/agregar-direccion')
  }

  editarDireccion(id:number){
    this.route.navigateByUrl('/pages/editar-direccion/' + id)
  }


  eliminarDireccion(id) {
    Swal.fire({
      title: 'Eliminar',
      text: '¿Está seguro de eliminar la dirección?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.value) {
        this.direccionesService.eliminarDireccion(id).subscribe(res => {
          this.obtenerDirecciones();
          Swal.fire(
            'Eliminado!',
            'La dirección ha sido eliminado correctamente!',
            'success'
          );
        }, err => {
          Swal.fire(
            'Error en la operación',
            'Error al intentar eliminar la dirección',
            'error'
          );
        });
      }
    })
  }

  changeValue(checked) {
    if (checked) {
      Swal.fire({
        title: 'Cambiar Dirección',
        text: '¿Quiere poner esta dirección como predeterminada?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: "Cancelar"
      })
    }
    else {
      Swal.fire({
        title: 'No Cambiar Dirección',
        text: '¿Quiere poner esta dirección como predeterminada?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: "Cancelar"
      })
    }
  }

  cambiarEstatus(id) {
    Swal.fire({
      title: 'Cambiar Dirección',
      text: '¿Quiere poner esta dirección como predeterminada?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.value) {
        this.direccionesService.cambiarEstatus(id).subscribe(res => {
          this.obtenerDirecciones();
          Swal.fire(
            'Correcto!',
            'La dirección ha sido predeterminada!',
            'success'
          );
        }, err => {
          Swal.fire(
            'Error en la operación',
            'Error al intentar cambiar la dirección',
            'error'
          );
        });
      }
    })
  }

}
